import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");


//action
export const deskTicketCreate = createAsyncThunk("deskTicketCreate", async ( data,{rejectWithValue}) => {
	try {
		const response = await axiosHttp.post(`desk/ticket/create`, data);
		message.success("Your Ticket has been created successfully!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const TicketCreateSlice = createSlice({
	name: "TicketCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	
	reducers: {
		resetTicketCreateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},
	
	extraReducers: (builder) => {
		builder.addCase(deskTicketCreate.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(deskTicketCreate.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(deskTicketCreate.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetTicketCreateState } = TicketCreateSlice.actions;
export default TicketCreateSlice.reducer;
